import styled from 'styled-components';
import { useEffect, useRef } from 'react';
import { DragHandleIcon } from 'foundations-assets';
import { MOVING_WIDGET, START_DRAGGING, STOP_DRAGGING } from 'calling-integration-remote-app/constants/message';
import { sendMessageToParent } from '../utils/message';
import { jsx as _jsx } from "react/jsx-runtime";
export const DRAG_BAR_HEIGHT = 18;
const Drag = styled.div.withConfig({
  displayName: "HeaderDragBar__Drag",
  componentId: "sc-1xocave-0"
})(["position:absolute;left:0;right:0;height:", "px;display:flex;justify-content:center;align-items:center;flex-grow:1;cursor:grab;z-index:1;> *{transform:rotate(90deg);}"], DRAG_BAR_HEIGHT);
export const HeaderDragBar = () => {
  const dragBarRef = useRef(null);
  useEffect(() => {
    const dragBar = dragBarRef.current;
    let baseMouseX = 0;
    let baseMouseY = 0;
    const handleMouseMove = mouseEvent => {
      mouseEvent.preventDefault();
      sendMessageToParent({
        name: MOVING_WIDGET,
        payload: {
          offsetX: mouseEvent.clientX - baseMouseX,
          offsetY: mouseEvent.clientY - baseMouseY,
          pageX: mouseEvent.pageX,
          pageY: mouseEvent.pageY
        }
      });
    };
    const onMouseStop = () => {
      if (!(dragBarRef !== null && dragBarRef !== void 0 && dragBarRef.current)) return;
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', onMouseStop);
      sendMessageToParent({
        name: STOP_DRAGGING
      });
    };
    const handleMouseDown = mouseDown => {
      mouseDown.preventDefault();
      baseMouseX = mouseDown.clientX;
      baseMouseY = mouseDown.clientY;
      const message = {
        name: START_DRAGGING,
        payload: {
          baseMouseX,
          baseMouseY
        }
      };
      sendMessageToParent(message);
      document.addEventListener('mouseup', onMouseStop);
      document.addEventListener('mousemove', handleMouseMove);
    };
    if (dragBar) {
      dragBar.addEventListener('mousedown', handleMouseDown);
    }
    return () => {
      onMouseStop();
      if (dragBar) {
        dragBar.removeEventListener('mousedown', handleMouseDown);
      }
    };
  }, []);
  return /*#__PURE__*/_jsx(Drag, {
    "data-selenium-test": "drag-bar",
    ref: dragBarRef,
    children: /*#__PURE__*/_jsx(DragHandleIcon, {
      size: "400",
      color: "icon-core-subtle"
    })
  });
};